import React from 'react';
import astore from 'assets/auth/astore-small.png';
import gplay from 'assets/auth/gplay-small.png';

import styles from './GetTheAppHeader.scss';

const GetTheAppHeader = () => (
  <div className={styles.base}>
    <span>Get the app for the full experience</span>
    <div>
      <a href="https://itunes.apple.com/us/app/dreamhack/id1390494035?mt=8" target="_blank" rel="noopener noreferrer">
        <img src={astore} alt="Download on the App Store" />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.dreamhack.app" target="_blank" rel="noopener noreferrer">
        <img src={gplay} alt="Get in on Google Play" />
      </a>
    </div>
  </div>
);

export default GetTheAppHeader;
